import type { MatchWeights } from './types.js';

/**
 * 匹配权重（v1.2「项目需求驱动」）。
 * 设计原则：**需求覆盖优先**，其次看团队结构互补，再看时间与跨校。
 * 变更须同步更新 test/matching.test.ts 的断言与 docs/架构设计.md 的算法章节。
 */
export const DEFAULT_WEIGHTS: MatchWeights = {
  coverage: 0.4,
  complement: 0.25,
  time: 0.2,
  crossSchool: 0.15,
};

export const WEIGHT_SUM_TOLERANCE = 1e-6;

export function assertWeights(w: MatchWeights): void {
  const sum = w.coverage + w.complement + w.time + w.crossSchool;
  if (Math.abs(sum - 1) > WEIGHT_SUM_TOLERANCE) {
    throw new Error(`匹配权重之和必须为 1，当前为 ${sum}`);
  }
  for (const [k, v] of Object.entries(w)) {
    if (v < 0 || v > 1) throw new Error(`权重 ${k}=${v} 必须在 0–1 之间`);
  }
}

/** 人话版权重说明，直接用于界面与答辩「分数怎么算」 */
export function describeWeights(w: MatchWeights = DEFAULT_WEIGHTS): string {
  const pct = (n: number) => `${Math.round(n * 100)}%`;
  return `需求覆盖 ${pct(w.coverage)} ＋ 团队互补 ${pct(w.complement)} ＋ 时间协同 ${pct(w.time)} ＋ 跨校 ${pct(w.crossSchool)}`;
}